import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import React from "react";

export const SummaryTableRow = ({ label, children }) => (
  <TableRow>
    <TableCell component="th" scope="row" sx={{ pl: 0 }}>
      {label}
    </TableCell>
    <TableCell sx={{ pr: 0 }}>{children}</TableCell>
  </TableRow>
);
export const SummaryTable = ({ children, sx }) => {
  return (
    <Table size="small" sx={sx}>
      <TableBody>{children}</TableBody>
    </Table>
  );
};
